import React from 'react';
import { Carousel, Card } from 'react-bootstrap';
import JumboContainer from './common/JumboContainer';

import '../styles/Testimonial.css'
import { faArrowCircleLeft, faArrowCircleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Farmer1 from '../assets/images/farmer1.png';
import Farmer2 from '../assets/images/farmer2.png';
import Farmer3 from '../assets/images/farmer3.png';
import { useTranslation } from 'react-i18next';
import { TESTIMONIAL_DESCRIPTION, TESTIMONIAL_LABEL } from '../data/i18n/testimonial';

const testimonials = [
  {
    image: Farmer1,
    farmerName: "Naresh Sharma",
    review: `छोटे खेत होने की वजह से हमारी पैदावार हमेशा कम होती थी और कभी तो  फसलों में रोग लगने के कारण बहुत भारी नुकसान भी होता था।  लेकिन फिर  फ़्रेशोकार्ट्ज़ के अग्रि एक्सपर्ट ने खेती की बुवाई से कटाई तक की सम्पूर्ण जानकारी कालिंग के द्वारा हमे मुफ्त में उपलब्ध कराई , इसके साथ साथ घर बैठे हमे उत्तम क्वालिटी के बीज, खाद और कीटनाशक एक दम उचित दामों पर उपलब्ध कराये। इन सब सुविधाओं के परिणाम स्वरुप न सिर्फ हमारी पैदावार बढ़ी बल्कि हमारा उत्पादन भी फ़्रेशोकार्ट्ज़ ने बढ़िया दामों पर खरीद लिया।`,
  },
  {
    image: Farmer2,
    farmerName: "Shyam Lal",
    review: `कई सालों से कृषि एक दम पारम्परिक तरीकों से की जाती रही थी, लेकिन फ़्रेशोकार्त्तज ने हमारे गाँव में कार्यशालाओं के माध्यम से हमें अलग अलग विभिन्न पहलुओं की जानकारी दी | सॉइल टेस्टिंग के जरिये मिट्टी की जाँच कर उसके अनुसार खेती की प्लानिंग समझायी गयी, साथ ही कृषि विशेषज्ञों ने खेतों में परीक्षण कर फसलों में होने वाले रोगों की जानकारी, दवाई और इलाज बताया। इसके अलावा अग्रि की टीम से मुफ्त कालिंग के जरिये घर बैठे ही हमें कृषि का सामान भी उपलब्ध कराया गया | बुवाई से लेकर कटाई तक की सारी सहायता हमें अग्रि एक्सपर्ट्स से कालिंग व खेतों के नियमित दौरों के जरिये हमारी पैदावार भी बढ़ी और कृषि के खर्चे में भी बहुत कमी आयी है |`,
  },
  {
    image: Farmer3,
    farmerName: "Nana Devi | Suman Devi",
    review: `छोटे खेत होने के कारण मेरे पति को परिवार का भरण पोषण करने के लिए दूर दराज के क्षेत्र में काम करना पड़ता है, जिसकी वजह से खेती और परिवार का सारा जिम्मा मुझ पर आ गया था। गांव के आस पास कोई दुकान न होने से खेत को खाली छोड़कर जाना बहुत ही मुश्किल होता था और कोई साधन ना होने कि वजह से पूरा दिन बर्बाद हो जाता था और खर्चा भी बहुत आता था। लेकिन फ्रेशोकार्ट ने न सिर्फ घर बैठे सामान उपलब्ध कराया बल्कि खेती अच्छे से हो सके और पैदावार बढ़े इसके लिए सहायता केंद्र की सुविधा भी रखी जंहा हमे बुवाई से कटाई तक की सारी जानकारी मुफ्त उपलब्ध कराई गयी। फ्रेशोकार्ट ने मेरे साथ साथ और भी बहुत किसान बहनों को लाभ पहुँचाया है।`,
  }
]

const Testimonial = () => {

  const {t} = useTranslation();

  return (
    <JumboContainer id="testimonials" title={t(TESTIMONIAL_LABEL)} subtitle={t(TESTIMONIAL_DESCRIPTION)}>
      <Carousel
        nextIcon={
          <FontAwesomeIcon color="black" icon={faArrowCircleRight} />
        }
        prevIcon={
          <FontAwesomeIcon color="black" icon={faArrowCircleLeft} />
        }
      >
        {
          testimonials.map(testimonial => (
            <Carousel.Item>
              <Card style={{
                  padding: '20px',
                  borderWidth: 0,
                  margin: '0 auto',
                  textAlign: 'center',
                  backgroundColor: 'inherit'
                }}>
                <Card.Img class="team-memeber_image" variant="top" src={testimonial.image} />
                <Card.Body>
                  <Card.Title class="team-member_name">{testimonial.farmerName}</Card.Title>
                  <Card.Text>
                    <p class="team-member_motivation">{testimonial.review}</p>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Carousel.Item>
          ))
        }
      </Carousel>
    </JumboContainer>
  );
}

export default Testimonial;